!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ml = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ml",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return t ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "വർഷം",
        relative: {
          0: "ഈ വർ‌ഷം",
          1: "അടുത്തവർഷം",
          "-1": "കഴിഞ്ഞ വർഷം"
        },
        relativeTime: {
          future: {
            one: "{0} വർഷത്തിൽ",
            other: "{0} വർഷത്തിൽ"
          },
          past: {
            one: "{0} വർഷം മുമ്പ്",
            other: "{0} വർഷം മുമ്പ്"
          }
        }
      },
      "year-short": {
        displayName: "വ.",
        relative: {
          0: "ഈ വർ‌ഷം",
          1: "അടുത്തവർഷം",
          "-1": "കഴിഞ്ഞ വർഷം"
        },
        relativeTime: {
          future: {
            one: "{0} വർഷത്തിൽ",
            other: "{0} വർഷത്തിൽ"
          },
          past: {
            one: "{0} വർഷം മുമ്പ്",
            other: "{0} വർഷം മുമ്പ്"
          }
        }
      },
      month: {
        displayName: "മാസം",
        relative: {
          0: "ഈ മാസം",
          1: "അടുത്ത മാസം",
          "-1": "കഴിഞ്ഞ മാസം"
        },
        relativeTime: {
          future: {
            one: "{0} മാസത്തിൽ",
            other: "{0} മാസത്തിൽ"
          },
          past: {
            one: "{0} മാസം മുമ്പ്",
            other: "{0} മാസം മുമ്പ്"
          }
        }
      },
      "month-short": {
        displayName: "മാ.",
        relative: {
          0: "ഈ മാസം",
          1: "അടുത്ത മാസം",
          "-1": "കഴിഞ്ഞ മാസം"
        },
        relativeTime: {
          future: {
            one: "{0} മാസത്തിൽ",
            other: "{0} മാസത്തിൽ"
          },
          past: {
            one: "{0} മാസം മുമ്പ്",
            other: "{0} മാസം മുമ്പ്"
          }
        }
      },
      day: {
        displayName: "ദിവസം",
        relative: {
          0: "ഇന്ന്",
          1: "നാളെ",
          2: "മറ്റന്നാൾ",
          "-2": "മിനിഞ്ഞാന്ന്",
          "-1": "ഇന്നലെ"
        },
        relativeTime: {
          future: {
            one: "{0} ദിവസത്തിൽ",
            other: "{0} ദിവസത്തിൽ"
          },
          past: {
            one: "{0} ദിവസം മുമ്പ്",
            other: "{0} ദിവസം മുമ്പ്"
          }
        }
      },
      "day-short": {
        displayName: "ദിവസം",
        relative: {
          0: "ഇന്ന്",
          1: "നാളെ",
          2: "മറ്റന്നാൾ",
          "-2": "മിനിഞ്ഞാന്ന്",
          "-1": "ഇന്നലെ"
        },
        relativeTime: {
          future: {
            one: "{0} ദിവസത്തിൽ",
            other: "{0} ദിവസത്തിൽ"
          },
          past: {
            one: "{0} ദിവസം മുമ്പ്",
            other: "{0} ദിവസം മുമ്പ്"
          }
        }
      },
      hour: {
        displayName: "മണിക്കൂർ",
        relative: {
          0: "ഈ മണിക്കൂറിൽ"
        },
        relativeTime: {
          future: {
            one: "{0} മണിക്കൂറിൽ",
            other: "{0} മണിക്കൂറിൽ"
          },
          past: {
            one: "{0} മണിക്കൂർ മുമ്പ്",
            other: "{0} മണിക്കൂർ മുമ്പ്"
          }
        }
      },
      "hour-short": {
        displayName: "മ.",
        relative: {
          0: "ഈ മണിക്കൂറിൽ"
        },
        relativeTime: {
          future: {
            one: "{0} മണിക്കൂറിൽ",
            other: "{0} മണിക്കൂറിൽ"
          },
          past: {
            one: "{0} മണിക്കൂർ മുമ്പ്",
            other: "{0} മണിക്കൂർ മുമ്പ്"
          }
        }
      },
      minute: {
        displayName: "മിനിറ്റ്",
        relative: {
          0: "ഈ മിനിറ്റിൽ"
        },
        relativeTime: {
          future: {
            one: "{0} മിനിറ്റിൽ",
            other: "{0} മിനിറ്റിൽ"
          },
          past: {
            one: "{0} മിനിറ്റ് മുമ്പ്",
            other: "{0} മിനിറ്റ് മുമ്പ്"
          }
        }
      },
      "minute-short": {
        displayName: "മി.",
        relative: {
          0: "ഈ മിനിറ്റിൽ"
        },
        relativeTime: {
          future: {
            one: "{0} മിനിറ്റിൽ",
            other: "{0} മിനിറ്റിൽ"
          },
          past: {
            one: "{0} മിനിറ്റ് മുമ്പ്",
            other: "{0} മിനിറ്റ് മുമ്പ്"
          }
        }
      },
      second: {
        displayName: "സെക്കൻഡ്",
        relative: {
          0: "ഇപ്പോൾ"
        },
        relativeTime: {
          future: {
            one: "{0} സെക്കൻഡിൽ",
            other: "{0} സെക്കൻഡിൽ"
          },
          past: {
            one: "{0} സെക്കൻഡ് മുമ്പ്",
            other: "{0} സെക്കൻഡ് മുമ്പ്"
          }
        }
      },
      "second-short": {
        displayName: "സെ.",
        relative: {
          0: "ഇപ്പോൾ"
        },
        relativeTime: {
          future: {
            one: "{0} സെക്കൻഡിൽ",
            other: "{0} സെക്കൻഡിൽ"
          },
          past: {
            one: "{0} സെക്കൻഡ് മുമ്പ്",
            other: "{0} സെക്കൻഡ് മുമ്പ്"
          }
        }
      }
    }
  }];
});